module.exports = __webpack_public_path__ + "static/media/download.f75f9f0e.svg";